import * as ContactsActions from './contacts.reducer'

export const { addContact, filterContacts } = ContactsActions
